




import { Component, Vue } from 'vue-property-decorator';

import { NavigationGuardNext, Route } from 'vue-router';

import authModule from '@/store/Auth';

// this component is just a stub to redirect to the first property

@Component({
  components: {},
})
export default class PropertyStub extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (!authModule.isExpert) {
      let propertyId = authModule.defaultPropertyId;
      if (!propertyId) {
        if (authModule.myProperties.length) {
          propertyId = authModule.myProperties[0].id as string;
        } else {
          console.warn('no property!');
          next();
          return;
        }
      }
      next({
        name: 'property-overview',
        params: { propertyId },
      });
    } else {
      next({
        name: 'expert-dashboard-properties',
      });
    }
  }
}
